import { withFieldConfigLayoutTabs } from "../components/withFieldConfigLayoutTabs.js";
import "react";
import { Checkbox, FormLayout, Text } from "@therms/atalaya";
import { jsx, jsxs } from "react/jsx-runtime";
//#region src/modules/FormBuilder/components/Fields/User/Config.tsx
var UserFieldConfig = withFieldConfigLayoutTabs(({ config, layoutType, setMultipleOptionsKeys, setOptions, setOptionsKey }) => {
	if (layoutType === "Display") return /* @__PURE__ */ jsx(FormLayout, {
		space: "sm",
		children: /* @__PURE__ */ jsx(Text, {
			onChangeValue: (value) => setOptionsKey("displayLabel", value),
			label: "Label",
			value: config.options.displayLabel
		})
	});
	return /* @__PURE__ */ jsx("div", { children: /* @__PURE__ */ jsxs(FormLayout, {
		space: "sm",
		children: [
			/* @__PURE__ */ jsx(Text, {
				label: "Label",
				onChangeValue: (value) => {
					if (config.options.displayLabel === config.options.formLabel) setMultipleOptionsKeys([["formLabel", value], ["displayLabel", value]]);
					else setOptionsKey("formLabel", value);
				},
				value: config.options.formLabel
			}),
			/* @__PURE__ */ jsx(Text, {
				onChangeValue: (value) => setOptionsKey("subText", value),
				label: "Sub Text",
				value: config.options.subText
			}),
			/* @__PURE__ */ jsx(Checkbox, {
				active: !!config.options.required,
				label: "Required",
				onChangeValue: (active) => setOptionsKey("required", active),
				subText: "Make this a required field"
			}),
			/* @__PURE__ */ jsx(Checkbox, {
				active: !!config.options.multi,
				label: "Allow multi-select",
				onChangeValue: (active) => setOptionsKey("multi", active),
				subText: "Allow the user to select multiple options"
			})
		]
	}) });
});
//#endregion
export { UserFieldConfig };

//# sourceMappingURL=Config.js.map